export default __webpack_public_path__ + "static/media/statIcon.72de2b54.svg";